var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22 0L22 22L0 22L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tarjeta-de-credito"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22 0L22 22L0 22L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 2.0195312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7297 12.4627L17.5945 12.4627C17.8144 12.4627 17.9611 12.3161 17.9611 12.0962L17.9611 8.7972C17.9611 8.57727 17.8144 8.43066 17.5945 8.43066L11.7297 8.43066C11.5098 8.43066 11.3632 8.57727 11.3632 8.7972L11.3632 12.0962C11.3631 12.3161 11.5098 12.4627 11.7297 12.4627L11.7297 12.4627ZM12.0963 9.16371L17.228 9.16371L17.228 11.7296L12.0963 11.7296L12.0963 9.16371L12.0963 9.16371Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83279 7.69759L4.76522 7.69759C4.98515 7.69759 5.13176 7.55099 5.13176 7.33106C5.13176 7.11112 4.98515 6.96452 4.76522 6.96452L1.83279 6.96452C1.61286 6.96452 1.46625 7.11112 1.46625 7.33106C1.46625 7.55099 1.61286 7.69759 1.83279 7.69759L1.83279 7.69759Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23138 7.69759L9.16381 7.69759C9.38374 7.69759 9.53035 7.55099 9.53035 7.33106C9.53035 7.11112 9.38374 6.96452 9.16381 6.96452L6.23138 6.96452C6.01145 6.96452 5.86484 7.11112 5.86484 7.33106C5.86484 7.55099 6.01145 7.69759 6.23138 7.69759L6.23138 7.69759Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83279 9.16379L6.59795 9.16379C6.81789 9.16379 6.96449 9.01718 6.96449 8.79725C6.96449 8.57732 6.81789 8.43071 6.59795 8.43071L1.83279 8.43071C1.61286 8.43071 1.46625 8.57732 1.46625 8.79725C1.46625 9.01718 1.61286 9.16379 1.83279 9.16379L1.83279 9.16379Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16381 8.43071L8.06415 8.43071C7.84422 8.43071 7.69762 8.57732 7.69762 8.79725C7.69762 9.01718 7.84422 9.16379 8.06415 9.16379L9.16381 9.16379C9.38374 9.16379 9.53035 9.01718 9.53035 8.79725C9.53035 8.57732 9.38374 8.43071 9.16381 8.43071L9.16381 8.43071Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6632 3.88544C21.4067 3.55554 21.0768 3.37225 20.6735 3.33561L19.7938 3.22899L19.7938 2.19927L19.7938 1.46619C19.7938 0.659794 19.134 0 18.3276 0L1.46619 0C0.659794 -4.30956e-05 0 0.659751 0 1.46619L0 2.19931L0 5.13174L0 13.1959C0 13.8579 0.444888 14.4209 1.05039 14.6013C1.03192 15.3428 1.59296 15.9865 2.34596 16.055L19.2807 17.961C19.3173 17.961 19.3906 17.961 19.4273 17.961C20.1604 17.961 20.8202 17.4112 20.8935 16.7148L21.9931 4.94845C22.0298 4.58187 21.9198 4.17865 21.6632 3.88544L21.6632 3.88544ZM0.733098 2.56582L19.0607 2.56582L19.0607 3.51887L19.0607 4.76513L0.733098 4.76513L0.733098 2.56582L0.733098 2.56582ZM1.46617 0.733042L18.3276 0.733042C18.7308 0.733042 19.0607 1.06294 19.0607 1.46616L19.0607 1.8327L0.733098 1.8327L0.733098 1.46616C0.733098 1.06294 1.063 0.733042 1.46617 0.733042L1.46617 0.733042ZM0.733098 13.1958L0.733098 5.49821L19.0607 5.49821L19.0607 13.1958C19.0607 13.599 18.7308 13.9289 18.3276 13.9289L1.50286 13.9289L1.46622 13.9289C1.063 13.9289 0.733098 13.599 0.733098 13.1958L0.733098 13.1958ZM21.26 4.80186L20.1603 16.5682C20.1237 16.9714 19.7571 17.2646 19.3539 17.228L2.45587 15.3219C2.08933 15.2853 1.83271 14.992 1.79607 14.6621L18.3276 14.6621C19.134 14.6621 19.7938 14.0023 19.7938 13.1959L19.7938 5.13175L19.7938 3.92213L20.6368 3.99545C20.8201 3.99545 21.0034 4.10542 21.1133 4.25203C21.2233 4.39863 21.2967 4.61856 21.26 4.80186L21.26 4.80186Z",
    id: "Forma",
    fill: "#32A6DC",
    fillRule: "evenodd",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.55055e57b97b0386eff67bff2216940f.svg";
export { ForwardRef as ReactComponent };